import {useContext} from "react";

import ContextMobileDatePicker from "../context/context-mobile-date-picker";

export const useMobileDatePicker = () => {
    return useContext(ContextMobileDatePicker)
}
